import axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { UnsecureSetupContext } from 'src/consumer/context/UnsecureSetupContext';
import { apiURL, commonHeadersWeb } from 'src/consumer/services';
import { HighlightedLeaders, UsersList } from './LeaderboardPageComponents';
import { LeaderboardSectionContainer } from './LeaderboardPageStyles';


export default function Leaderboard({ profileData, setupData }) {

    const { unSecureSetupLoading, unSecureSetupData, unSecureSetupError } = useContext(UnsecureSetupContext)

    const [primaryCriteria, setPrimaryCriteria] = useState(setupData?.statFields?.[0]?.id);

    const token = localStorage.getItem('token');
    const countryCode = localStorage.getItem('countryCode');

    const [nationalLeadersData, setNationalLeadersData] = useState(null);
    const [nationalRankData, setNationalRankData] = useState(null);
    const [globalLeadersData, setGlobalLeadersData] = useState(null);
    const [globalRankData, setGlobalRankData] = useState(null);
    const [comparisonMode, setComparisonMode] = useState("global")

    const getLeaders = async () => {
        try {
            const response = await axios.get(`${apiURL}/api/secure/leaderboard?primaryCriteria=${primaryCriteria}&country=${countryCode}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    ...commonHeadersWeb,
                    'ef-user-country-code': localStorage.getItem('countryCode'),
                    'ef-app-language': sessionStorage.getItem('languageCode')
                }
            });
            setNationalLeadersData(response?.data)
            return response;
        } catch (error) {
            console.log(error)
            return (error);
        }
    }

    const getMyRank = async () => {
        try {
            const response = await axios.get(`${apiURL}/api/secure/user/leaderboard/my-rank?primaryCriteria=${primaryCriteria}&country=${countryCode}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    ...commonHeadersWeb,
                    'ef-user-country-code': localStorage.getItem('countryCode'),
                    'ef-app-language': sessionStorage.getItem('languageCode')
                }
            });
            setNationalRankData(response?.data)
            return response;
        } catch (error) {
            console.log(error)
            return (error);
        }
    }

    const getLeadersGlobal = async () => {
        try {
            const response = await axios.get(`${apiURL}/api/secure/leaderboard?primaryCriteria=${primaryCriteria}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    ...commonHeadersWeb,
                    'ef-user-country-code': localStorage.getItem('countryCode'),
                    'ef-app-language': sessionStorage.getItem('languageCode')
                }
            });
            setGlobalLeadersData(response?.data)
            return response;
        } catch (error) {
            console.log(error)
            return (error);
        }
    }

    const getMyRankGlobal = async () => {
        try {
            const response = await axios.get(`${apiURL}/api/secure/user/leaderboard/my-rank?primaryCriteria=${primaryCriteria}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    ...commonHeadersWeb,
                    'ef-user-country-code': localStorage.getItem('countryCode'),
                    'ef-app-language': sessionStorage.getItem('languageCode')
                }
            });
            setGlobalRankData(response?.data)
            return response;
        } catch (error) {
            console.log(error)
            return (error);
        }
    }

    useEffect(() => {
        getLeaders();
        getLeadersGlobal();
        if (profileData?.[primaryCriteria] > 0) {
            getMyRank();
            getMyRankGlobal();
        } else {
            setNationalRankData("ineligible");
            setGlobalRankData("ineligible");
        }
    }, [primaryCriteria])

    return (

        <>
            {(Boolean(nationalLeadersData) && Boolean(globalLeadersData)) ?
                <LeaderboardSectionContainer>
                    <HighlightedLeaders
                        nationalLeadersData={nationalLeadersData}
                        nationalRankData={nationalRankData}
                        globalLeadersData={globalLeadersData}
                        globalRankData={globalRankData}
                        comparisonMode={comparisonMode}
                        setComparisonMode={setComparisonMode}
                        primaryCriteria={primaryCriteria}
                        setPrimaryCriteria={setPrimaryCriteria}
                        profileData={profileData}
                        unSecureSetupData={unSecureSetupData}
                        statFields={setupData?.statFields}
                    />

                    <UsersList
                        nationalLeadersData={nationalLeadersData}
                        nationalRankData={nationalRankData}
                        globalLeadersData={globalLeadersData}
                        globalRankData={globalRankData}
                        comparisonMode={comparisonMode}
                        setComparisonMode={setComparisonMode}
                        primaryCriteria={primaryCriteria}
                        setPrimaryCriteria={setPrimaryCriteria}
                        profileData={profileData}
                        unSecureSetupData={unSecureSetupData}
                        statFields={setupData?.statFields}
                    />
                </LeaderboardSectionContainer> :
                <Spinner animation="border" variant="light" size="md" />
            }
        </>

    )
}
